import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "home-hot-container"
};
const _hoisted_2 = {
  class: "home-hot-dashboard"
};
const _hoisted_3 = {
  key: 0,
  class: "home-hot-loading"
};
const _hoisted_4 = {
  key: 1,
  class: "home-hot-card-group"
};
const _hoisted_5 = {
  class: "home-article-section"
};
import { ref, onMounted, computed } from 'vue';
import { getDailyQuote } from '../utils/quotes.js';

// "今天炒什么"数据加载

export default {
  __name: 'Hot',
  setup(__props) {
    const loading = ref(true);
    const conceptList = ref([]); // "今天炒什么"数据列表
    // const today = new Date() // 当前日期

    // 每日名言统一数据源见 src/utils/quotes.js
    // 根据天数自动切换每日名言
    const dailyQuote = computed(() => getDailyQuote());

    // 拉取"今天炒什么"数据
    const fetchData = async () => {
      loading.value = true;
      try {
        var _result$data;
        const res = await fetch('/iwc-api/unifiedwap/unified-wap/index/iwc-index');
        const result = await res.json();
        // 解析"今天炒什么"
        conceptList.value = ((_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.concept_data) === null || _result$data === void 0 ? void 0 : _result$data.list) || [];
      } catch (e) {
        conceptList.value = [];
      }
      loading.value = false;
    };
    onMounted(() => {
      fetchData();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("main", _hoisted_2, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "home-hot-loading-gradient"
      }, null, -1), _createElementVNode("p", null, "正在加载风向数据...", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_4)), _createElementVNode("div", _hoisted_5, _toDisplayString(dailyQuote.value.en) + " " + _toDisplayString(dailyQuote.value.zh), 1)])]);
    };
  }
};